var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.14,
    y: 117.18,
    width: 242.28,
    height: 233.54,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.03,
    y: 121.42,
    width: 238.39,
    height: 225.22,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.79 292.1 208.79 224.35 215.82 224.35 215.82 215.4 231.66 208 231.66 198.84 234.3 198.84 234.3 224.35 236.94 224.35 236.94 292.1 240.46 292.1 240.46 256.9 248.38 256.9 248.38 238.43 251.02 238.43 251.02 292.1 257.17 292.1 257.17 271.86 261.57 271.86 261.57 266.58 271.25 266.58 271.25 248.11 276.53 248.11 276.53 235.79 282.69 235.79 282.69 217.31 285.33 217.31 285.33 235.79 291.49 235.79 291.49 248.11 296.76 248.11 296.76 266.58 306.44 266.58 306.44 271.86 310.84 271.86 310.84 292.1 316.12 292.1 316.12 266.58 325.8 266.58 325.8 210.28 328.44 210.28 328.44 204.12 349.55 204.12 349.55 210.28 353.95 210.28 353.95 250.75 371.55 250.75 371.55 255.14 377.7 255.14 377.7 257.78 371.55 257.78 371.55 273.62 390.02 273.62 390.02 220.83 393.54 220.83 393.54 210.28 402.34 210.28 402.34 169.81 404.98 169.81 404.98 210.28 411.14 210.28 411.14 220.83 445.42 220.83 445.42 346.64 207.03 346.64 207.03 292.1 208.79 292.1",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.61,
    y: 223.59,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.61,
    y: 227.77,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.61,
    y: 244.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.61,
    y: 248.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.61,
    y: 252.84,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.61,
    y: 265.38,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.61,
    y: 269.56,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.65,
    y: 240.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.65,
    y: 244.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.65,
    y: 248.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.65,
    y: 252.84,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.65,
    y: 257.02,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.65,
    y: 265.38,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.65,
    y: 269.56,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 223.59,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 227.77,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 231.95,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 236.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 240.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 244.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 248.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 252.84,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 257.02,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 261.2,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 269.56,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.73,
    y: 223.59,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.73,
    y: 227.77,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.73,
    y: 231.95,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.73,
    y: 236.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.73,
    y: 240.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.73,
    y: 244.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.73,
    y: 248.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.73,
    y: 286.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 223.59,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 227.77,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 231.95,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 236.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 240.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 244.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 248.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 252.84,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 277.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 282.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 286.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 290.45,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 307.17,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 223.59,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 227.77,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 231.95,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 236.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 240.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 244.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 248.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 252.84,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 257.02,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 261.2,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 273.74,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 277.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 282.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 286.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 290.45,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.81,
    y: 307.17,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 223.59,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 227.77,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 231.95,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 236.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 240.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 244.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 248.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 252.84,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 257.02,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 261.2,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 265.38,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 269.56,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 273.74,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 277.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 282.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 286.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 290.45,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 294.63,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 223.59,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 227.77,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 231.95,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 236.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 240.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 244.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 248.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 252.84,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 257.02,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 261.2,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 273.74,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 277.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 282.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.89,
    y: 286.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 223.59,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 227.77,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 231.95,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 236.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 240.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 244.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 248.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 252.84,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 257.02,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 261.2,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 273.74,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 277.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.94,
    y: 282.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.36,
    y: 212.74,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.36,
    y: 216.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.36,
    y: 221.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.36,
    y: 225.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.36,
    y: 229.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.36,
    y: 233.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.36,
    y: 237.81,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.36,
    y: 241.99,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.36,
    y: 254.53,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.36,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.4,
    y: 212.74,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.4,
    y: 216.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.4,
    y: 221.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.4,
    y: 225.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.4,
    y: 229.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.4,
    y: 233.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.4,
    y: 237.81,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.4,
    y: 241.99,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.4,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 212.74,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 216.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 221.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 225.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 229.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 233.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 237.81,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 241.99,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 212.74,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 216.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 221.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 225.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 229.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 233.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 241.99,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 246.17,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 262.89,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 267.07,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 271.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 275.43,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 279.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 283.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 212.74,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 216.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 221.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 225.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 229.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 233.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 246.17,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 250.35,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 254.53,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 262.89,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 267.07,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 271.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 275.43,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 279.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 283.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 287.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 296.32,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 212.74,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 216.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 221.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 225.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 229.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 233.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 246.17,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 250.35,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 254.53,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 271.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 275.43,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 279.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 283.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 287.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 296.32,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 300.5,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 289.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 293.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 297.57,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.68,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.68,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.68,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.68,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.68,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.68,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.68,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.72,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.72,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.72,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.72,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.72,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.72,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.72,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 280.85,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 285.03,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 289.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.76,
    y: 293.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 280.85,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 285.03,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 289.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 293.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 297.57,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 310.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8,
    y: 314.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 280.85,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 285.03,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 289.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 293.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 297.57,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 310.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 314.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 318.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 226.52,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 230.7,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 234.88,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 239.06,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 243.24,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 247.42,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 280.85,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 285.03,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 289.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 293.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 297.57,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 301.75,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 305.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 310.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 314.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.35,
    y: 318.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 226.52,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 230.7,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 234.88,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 239.06,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 243.24,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 247.42,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 280.85,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 285.03,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 289.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 293.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 297.57,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.39,
    y: 301.75,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 226.52,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 230.7,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 234.88,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 239.06,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 243.24,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 247.42,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 280.85,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 285.03,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 289.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 293.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 297.57,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.43,
    y: 301.75,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 226.52,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 230.7,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 234.88,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 239.06,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 243.24,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 247.42,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 280.85,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 285.03,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 226.52,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 230.7,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 234.88,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 239.06,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 243.24,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 247.42,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.51,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 226.52,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 230.7,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 234.88,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 239.06,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 243.24,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 247.42,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 251.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 255.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.55,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 225.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 229.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 233.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 237.81,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 241.99,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 246.17,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 250.35,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 254.53,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 262.89,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 267.07,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 271.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 275.43,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 279.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 283.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 287.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 292.14,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 300.5,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 304.68,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 308.86,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 313.04,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.64,
    y: 317.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 225.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 229.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 233.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 237.81,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 241.99,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 246.17,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 250.35,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 254.53,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 262.89,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 267.07,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 271.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 275.43,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 279.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 283.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 287.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 313.04,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.68,
    y: 317.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 225.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 229.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 233.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 237.81,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 241.99,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 246.17,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 250.35,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 254.53,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 262.89,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 267.07,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 271.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 275.43,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 279.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 283.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 287.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 296.32,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 300.5,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 304.68,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 308.86,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.73,
    y: 317.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 254.53,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 262.89,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 267.07,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 271.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 275.43,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 279.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 283.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 287.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 292.14,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 296.32,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 300.5,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 304.68,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 313.04,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 317.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 321.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 325.57,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 333.93,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 338.11,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 342.29,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 254.53,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 262.89,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 267.07,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 271.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 275.43,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 279.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 283.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 287.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 292.14,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 296.32,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 300.5,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 304.68,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 317.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 321.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 329.75,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 333.93,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 338.11,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 342.29,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 254.53,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 258.71,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 262.89,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 267.07,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 271.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 275.43,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 279.6,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 283.78,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 287.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 292.14,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 296.32,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 300.5,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 304.68,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 308.86,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 317.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 325.57,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 329.75,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 333.93,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 338.11,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.74,
    y: 342.29,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 278.36,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 282.54,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 286.72,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 290.89,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 295.07,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 299.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 311.79,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 315.97,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 320.15,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 324.33,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 328.51,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 332.68,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 336.86,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 278.36,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 282.54,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 286.72,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 290.89,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 295.07,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 299.25,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 311.79,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 315.97,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 320.15,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 324.33,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 328.51,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 332.68,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.83,
    y: 341.04,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 280.85,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 285.03,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 289.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 293.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 297.57,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 301.75,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 310.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 314.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 318.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 322.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 326.82,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 331,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 335.18,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 339.36,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 259.96,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 264.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 268.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 272.49,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 276.67,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 280.85,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 285.03,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 289.21,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 293.39,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 297.57,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 301.75,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 305.92,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 310.1,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 314.28,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 318.46,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 322.64,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 326.82,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 331,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 335.18,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.35,
    y: 339.36,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.81,
    y: 276.23,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.81,
    y: 280.41,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.81,
    y: 284.59,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.81,
    y: 288.77,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.81,
    y: 292.95,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.81,
    y: 297.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.81,
    y: 301.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.81,
    y: 305.48,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.81,
    y: 309.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.81,
    y: 313.84,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.85,
    y: 276.23,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.85,
    y: 280.41,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.85,
    y: 284.59,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.85,
    y: 288.77,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.85,
    y: 292.95,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.85,
    y: 297.13,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.85,
    y: 301.31,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.85,
    y: 305.48,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.85,
    y: 309.66,
    width: 2.49,
    height: 2.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.71,
    y: 117.64,
    width: 4.18,
    height: 233.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.42,
    y: 117.64,
    width: 4.18,
    height: 233.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.12,
    y: 117.64,
    width: 4.18,
    height: 233.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.82,328H173.6a4.41,4.41,0,0,1,4.41,4.41v49.83a0,0,0,0,1,0,0H143.42a0,0,0,0,1,0,0V332.45A4.41,4.41,0,0,1,147.82,328Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.42,
    y: 335.38,
    width: 34.59,
    height: 3.89,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.09,375.71h8.62a2.37,2.37,0,0,1,2.37,2.37v4.2a0,0,0,0,1,0,0H160.71a0,0,0,0,1,0,0v-4.2A2.37,2.37,0,0,1,163.09,375.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.12,382.28h-9.58a1.54,1.54,0,0,1-1.54-1.54h0a1.54,1.54,0,0,1,1.54-1.53h9.58a1.54,1.54,0,0,1,1.54,1.53h0A1.54,1.54,0,0,1,174.12,382.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.3,
    cy: 83.77,
    r: 23.55,
    transform: "translate(-10.62 76.29) rotate(-13.28)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.3,
    cy: 83.77,
    r: 20.03,
    transform: "translate(-9.26 52.71) rotate(-9.22)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "323.25 70.03 323.25 84.03 332.52 78.78",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.25,85a1,1,0,0,1-.51-.14,1,1,0,0,1-.49-.86V70a1,1,0,1,1,2,0V82.31l7.78-4.4a1,1,0,0,1,1.36.38,1,1,0,0,1-.37,1.36l-9.28,5.25A1.09,1.09,0,0,1,323.25,85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.93,313.64c-1.8-3-4.76-.39-4.76-.39.42-5.68-4.8-9.56-4.8-9.56s6.07,0,6.91-5.79-2.11-3.1-4.89-3.14-5.69,8.08-2,12.65,2.68,12.37-5.79,19.87a16.64,16.64,0,0,0-4.42,6.9c.64-6.89,1-16.6-1-23.08-3.44-11,3.12-14,5-19.48s-5-10.16-5-10.16,6.51-3,3.33-6.35-9.74-2.93-9.74,1.5,4.45,6.12,4.45,6.12,5.08,5.29,5.08,8-5.08,8.68-5.08,8.68,2.33-5.07-2.33-5.28-6.14,5.92-4.23,8.67,5.08.43,5.08.43a54,54,0,0,0,1.45,9.52c.48,1.59.26,7.8-.14,14.26a16.11,16.11,0,0,0-4.13-6.12c-8.47-7.5-9.45-15.3-5.78-19.87s.76-12.69-2-12.65-5.75-2.66-4.9,3.13,6.92,5.8,6.92,5.8-5.23,3.88-4.81,9.56c0,0-3-2.58-4.76.39-3.21,5.29,4.24,8.57,5.49,6,0,0,15.79,11.18,12,27.27l.88,1.31c-.11,1.3-.18,2.08-.18,2.08l1.23-.53,1.41,2.07a48.41,48.41,0,0,0,.36,7l3.77-5.58c-3.81-16.09,12-27.27,12-27.27C92.7,322.22,100.14,318.93,96.93,313.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.93,313.64c-1.8-3-4.76-.39-4.76-.39.42-5.68-4.8-9.56-4.8-9.56s6.07,0,6.91-5.79-2.11-3.1-4.89-3.14-5.69,8.08-2,12.65,2.68,12.37-5.79,19.87a16.64,16.64,0,0,0-4.42,6.9c.64-6.89,1-16.6-1-23.08-3.44-11,3.12-14,5-19.48s-5-10.16-5-10.16,6.51-3,3.33-6.35-9.74-2.93-9.74,1.5,4.45,6.12,4.45,6.12,5.08,5.29,5.08,8-5.08,8.68-5.08,8.68,2.33-5.07-2.33-5.28-6.14,5.92-4.23,8.67,5.08.43,5.08.43a54,54,0,0,0,1.45,9.52c.48,1.59.26,7.8-.14,14.26a16.11,16.11,0,0,0-4.13-6.12c-8.47-7.5-9.45-15.3-5.78-19.87s.76-12.69-2-12.65-5.75-2.66-4.9,3.13,6.92,5.8,6.92,5.8-5.23,3.88-4.81,9.56c0,0-3-2.58-4.76.39-3.21,5.29,4.24,8.57,5.49,6,0,0,15.79,11.18,12,27.27l.88,1.31c-.11,1.3-.18,2.08-.18,2.08l1.23-.53,1.41,2.07a48.41,48.41,0,0,0,.36,7l3.77-5.58c-3.81-16.09,12-27.27,12-27.27C92.7,322.22,100.14,318.93,96.93,313.64Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.84 382.28 57.67 382.28 53.77 342.68 97.75 342.68 93.84 382.28",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.83,
    y: 338.31,
    width: 47.84,
    height: 8.74,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.45,384.72c.15-1,3.65-25.17-3.36-33.51a7.59,7.59,0,0,0-5.82-2.87c-14.16-.33-16.09,11-16.11,11.15l1.67.26c.06-.41,1.74-10,14.4-9.72a5.92,5.92,0,0,1,4.57,2.26c6.52,7.77,3,31.93,3,32.18Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.3,383.62l1.69-.06c0-.22-.56-22.25,10.29-26.8,10.64-4.45,15.43,4.71,15.62,5.1l1.51-.76c-.05-.11-5.67-11-17.78-5.89C410.71,360.2,411.27,382.66,411.3,383.62Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.25,385.35c0-.35.11-35.19,6.9-45.38,6.52-9.79,17-5.18,17.49-5l.69-1.54c-.12-.05-12.26-5.41-19.59,5.58-7.07,10.61-7.17,44.86-7.17,46.32Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.24,349.18s6.18,2.28,4.34,7.65-21.37,14.23-21.37,14.23-8.19-7.5-.67-19.7S399.07,345.33,399.24,349.18Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.45,338.13s-4.38-.47-4-3.14,17.06-9.55,26.91,1.57c0,0-6.31,10.84-15.43,11S418.45,338.13,418.45,338.13Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,356s-3-2.44.24-3.63,19.3-.86,19.46,15c0,0-18.67,3.11-21-2.94S423,356,423,356Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.24,349.18s6.18,2.28,4.34,7.65-21.37,14.23-21.37,14.23-8.19-7.5-.67-19.7S399.07,345.33,399.24,349.18Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.45,338.13s-4.38-.47-4-3.14,17.06-9.55,26.91,1.57c0,0-6.31,10.84-15.43,11S418.45,338.13,418.45,338.13Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,356s-3-2.44.24-3.63,19.3-.86,19.46,15c0,0-18.67,3.11-21-2.94S423,356,423,356Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.92 417.07 424.9 417.07 428.02 385.35 392.8 385.35 395.92 417.07",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.92 417.07 424.9 417.07 428.02 385.35 392.8 385.35 395.92 417.07",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.25,
    y: 381.85,
    width: 38.32,
    height: 7,
    transform: "translate(820.82 770.69) rotate(180)",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.25,
    y: 381.85,
    width: 38.32,
    height: 7,
    transform: "translate(820.82 770.69) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.12,394.33l-28.81-2.83V351H322.89v40.48L294,394.33a5.61,5.61,0,0,0-5.06,5.58v4.33h79.28v-4.33A5.6,5.6,0,0,0,363.12,394.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.12,394.33l-28.81-2.83V351H322.89v40.48L294,394.33a5.61,5.61,0,0,0-5.06,5.58v4.33h79.28v-4.33A5.6,5.6,0,0,0,363.12,394.33Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.95,
    cy: 409.61,
    r: 7.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.14,
    cy: 409.61,
    r: 7.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.93,323.64h15.35a0,0,0,0,1,0,0v31.93a4.13,4.13,0,0,1-4.13,4.13h-7.09a4.13,4.13,0,0,1-4.13-4.13V323.64A0,0,0,0,1,320.93,323.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.93,323.64h15.35a0,0,0,0,1,0,0v31.93a4.13,4.13,0,0,1-4.13,4.13h-7.09a4.13,4.13,0,0,1-4.13-4.13V323.64A0,0,0,0,1,320.93,323.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,260.35s2.18,54-12.86,63.29h17.17s13.3-18.39,9.54-63.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,260.35s2.18,54-12.86,63.29h17.17s13.3-18.39,9.54-63.29Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.13,316.09h76.92a0,0,0,0,1,0,0v6.69a5,5,0,0,1-5,5H294.13a5,5,0,0,1-5-5v-6.69A0,0,0,0,1,289.13,316.09Z",
    transform: "translate(655.18 643.87) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.93,
    y: 321.94,
    width: 83.33,
    height: 5.84,
    rx: 2.01,
    transform: "translate(655.18 649.72) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.93,
    y: 321.94,
    width: 83.33,
    height: 5.84,
    rx: 2.01,
    transform: "translate(655.18 649.72) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.88,
    y: 231.4,
    width: 56.66,
    height: 39.92,
    rx: 14.58,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.05,187.28l-5.49-14.47s2.36-2.18.74-4.39-11.74-8.42-13.58-7.33-5.95,5.21-3.73,7.5,12,6.1,12,6.1l4.86,19Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.38,214.79s-25-5.13-27.67-6.36S261,177.77,261,177.77l-7.71,3.6s6.2,29.54,12.54,36.56,33.4,13,33.4,13Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,230.9l-.46-.11c-1.36-.31-5.63-1.31-10.7-2.8-8.23-2.39-18.61-6-22.23-10.05-6.33-7-12.54-36.57-12.54-36.57l7.7-3.6s10.05,29.44,12.77,30.66,27.67,6.36,27.67,6.36Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.07 177.19 262.66 180.26 252.76 183.67 253.14 179.92 261.07 177.19",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.36,230.49c-1.38-.2-5.71-.87-10.89-2,2.95-5.1,11.59-7.72,11.59-7.72Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.58,194.41s1.47,13.83-3.65,17.23-30.33-.58-33.19-6.15,7.9-20.67,7.9-20.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.59 376.39 241.17 377.98 244.5 368.9 247.52 360.64 240.03 357.45 237.15 367.47 234.59 376.39",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.15 367.47 244.5 368.9 247.52 360.64 240.03 357.45 237.15 367.47",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,362.68l9.12,3.39s24.33-60.83,29.33-61,55.91,23.19,68.67,10.21S339.24,271,339.24,271s-30.69-4.38-33,2.55a48.61,48.61,0,0,0-1.3,6.22c-.35,2.12-.59,3.9-.59,3.9h0c-.95-.24-31.76-8.19-43.9,0C248.1,292,237.81,362.68,237.81,362.68Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,362.68l9.12,3.39s24.33-60.83,29.33-61,55.91,23.19,68.67,10.21S339.24,271,339.24,271s-30.69-4.38-33,2.55a48.61,48.61,0,0,0-1.3,6.22c-.35,2.12-.59,3.9-.59,3.9h0c-.95-.24-31.76-8.19-43.9,0C248.1,292,237.81,362.68,237.81,362.68Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.27 402.34 296.82 400.67 295.56 391.26 294.39 382.64 286.29 383.37 288.39 393.42 290.27 402.34",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.44 393.62 295.6 391.44 294.41 382.73 286.3 383.42 288.44 393.62",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.7 362.69 237.41 358.18 236.84 363.62 246.92 367.18 250.7 362.69",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.89,318.36s-2.08.05-34.27-1.45c0,0,4.81,40.24,7.44,70.37l-9.63,1.64s-23-64.51-22.75-74.76,12-13.25,12-13.25S298.61,314.16,322.89,318.36Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.89,318.36s-2.08.05-34.27-1.45c0,0,4.81,40.24,7.44,70.37l-9.63,1.64s-23-64.51-22.75-74.76,12-13.25,12-13.25S298.61,314.16,322.89,318.36Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.89,318.36s-2.08.05-34.27-1.45c0,0,4.81,40.24,7.44,70.37l-9.63,1.64s-23-64.51-22.75-74.76,12-13.25,12-13.25S298.61,314.16,322.89,318.36Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.46 384.36 284.23 385.87 286.79 391.05 297.5 389.68 297.46 384.36",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.35,283.67l17.95,3.74s-9.92-5.48-17.36-7.64C304.59,281.89,304.35,283.67,304.35,283.67Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.5 266.23 339.24 271 306.24 273.55 305.37 267.9 338.5 266.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.5 266.23 339.24 271 306.24 273.55 305.37 267.9 338.5 266.23",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.66,
    y: 265.81,
    width: 1.64,
    height: 8.35,
    transform: "translate(682.85 504.96) rotate(174.13)",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.25,
    y: 267.66,
    width: 7.24,
    height: 5.49,
    transform: "translate(650.44 519.93) rotate(176.32)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.4,
    y: 266.7,
    width: 1.64,
    height: 8.35,
    transform: "translate(642.54 508.79) rotate(174.13)",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.66,
    y: 265.81,
    width: 1.64,
    height: 8.35,
    transform: "translate(682.85 504.96) rotate(174.13)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.4,
    y: 266.7,
    width: 1.64,
    height: 8.35,
    transform: "translate(642.54 508.79) rotate(174.13)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.78,214.34a60,60,0,0,0,19,2.09C330.38,215.89,343,221,343,221l-4.54,45.2-33.14,1.67S294.23,230.16,300.78,214.34Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.11,188.81s1.86-21.94,20.2-14c23,10,4.72,36.74-6.53,31.26S306.11,188.81,306.11,188.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25,217.66l.53,12.4,4.11-5.83s-1.47,13.71-.61,21.18c0,0,.79-13.39,2.65-21.18l4.37,5.83,6.27-12.32S318.42,214.09,311.25,217.66Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.93,220l9.49-2.68c-5.85-4-2.9-13-2.9-13l-9.4,3.3a27.67,27.67,0,0,1,1,4c1,5.86-1.66,6.33-1.66,6.33Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.12,207.57a27.67,27.67,0,0,1,1,4c4.5-1.81,8.39-7.32,8.39-7.32Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.26,179.45c-8.33-1.84-12,2-14.5,10.46-3.13,10.55-2.44,18.69,8.47,18.71C329.05,208.64,334.08,182.51,320.26,179.45Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.24,190.64a17.72,17.72,0,0,1-3.18,2.91,2.34,2.34,0,0,0,2,1.43Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.49,191.08c-.17.68.06,1.33.52,1.44s.95-.35,1.12-1-.06-1.32-.52-1.44S316.66,190.4,316.49,191.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.79,190.13l-1.33-.94S316.89,190.62,317.79,190.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07,188.86c-.17.68.06,1.33.52,1.44s1-.35,1.12-1-.06-1.32-.52-1.44S308.24,188.18,308.07,188.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.37,187.91,308,187S308.47,188.39,309.37,187.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.18,187.77a.37.37,0,0,1-.33-.19,4.09,4.09,0,0,0-3-1.86.38.38,0,0,1-.33-.4.37.37,0,0,1,.4-.33,4.79,4.79,0,0,1,3.62,2.26.36.36,0,0,1-.16.49A.45.45,0,0,1,321.18,187.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.87,184a.35.35,0,0,1-.19-.06,3.64,3.64,0,0,0-3.15,0,.35.35,0,0,1-.46-.2.36.36,0,0,1,.2-.47,4.31,4.31,0,0,1,3.8.08.36.36,0,0,1,.11.5A.37.37,0,0,1,311.87,184Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,195.49s-2.38-7.7-.62-12.85c0,0-15-10.39-19.52,6.17,0,0,1.67-15.22,16.06-12.38s9.68,23.75.91,28.35C323.08,204.78,327.71,200.3,326.25,195.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.5,197a3.74,3.74,0,0,1,4.67-2.47c2.52.85,2.57,6.42-4.12,6.27C324.08,200.73,323.76,199.72,324.5,197Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.55,198.14a21.29,21.29,0,0,1,.44,3.1l.54,0c2.49.21,3.71-.52,4.31-1.38a3.17,3.17,0,0,0,.52-1.43,3,3,0,0,0,0-.87,11.84,11.84,0,0,1-5,.59C308.88,198.18,308.55,198.14,308.55,198.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,198.2l.15.91c2.34.19,4,0,4.81-.63a3,3,0,0,0,0-.87A11.84,11.84,0,0,1,309.4,198.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.53,201.29c2.49.21,3.71-.52,4.31-1.38a8.07,8.07,0,0,0-2.8.31A3,3,0,0,0,309.53,201.29Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.29,180.12s.32,14.43,9,16.17-.8-18.56-.8-18.56-12.9-8.42-21.5-2.48-.86,13.56-.86,13.56S307.92,178.09,320.29,180.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6,193.33a.25.25,0,0,1-.16-.06c-6.16-4.84-3.12-14.1-3.09-14.19a.26.26,0,0,1,.32-.16.25.25,0,0,1,.15.32c0,.09-2.95,9,2.93,13.64a.24.24,0,0,1,0,.35A.22.22,0,0,1,323.6,193.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8,199.25c-1.1,2.94-3.93,4.59-6.32,3.7s-3.43-4-2.33-6.94,3.93-4.59,6.32-3.69S332.9,196.32,331.8,199.25Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8,199.25c-1.1,2.94-3.93,4.59-6.32,3.7s-3.43-4-2.33-6.94,3.93-4.59,6.32-3.69S332.9,196.32,331.8,199.25Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,194.44s3.59-16.07-4.46-20.28a22.24,22.24,0,0,1,2.72.53c1,.3,7.47,6.82,4.22,21.26Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,194.44s3.59-16.07-4.46-20.28a22.24,22.24,0,0,1,2.72.53c1,.3,7.47,6.82,4.22,21.26Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,203.64l-.6-.09.16-1a18.34,18.34,0,0,0,12.69-2.69l.59.8A18.85,18.85,0,0,1,314,203.64Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314,203.64l-.6-.09.16-1a18.34,18.34,0,0,0,12.69-2.69l.59.8A18.85,18.85,0,0,1,314,203.64Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M331.46,198.85c-.72,1.94-2.6,3-4.17,2.44s-2.27-2.64-1.54-4.58,2.6-3,4.17-2.44S332.19,196.91,331.46,198.85Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.06,204l-.81-.11a1.08,1.08,0,0,1-.93-1.22h0a1.08,1.08,0,0,1,1.22-.94l.8.11a1.1,1.1,0,0,1,.94,1.22h0A1.1,1.1,0,0,1,313.06,204Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.06,204l-.81-.11a1.08,1.08,0,0,1-.93-1.22h0a1.08,1.08,0,0,1,1.22-.94l.8.11a1.1,1.1,0,0,1,.94,1.22h0A1.1,1.1,0,0,1,313.06,204Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.87 213.85 317.93 219.68 320.31 226.84 328.57 217.74 323.87 213.85",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.28 215.07 316.24 219.56 313.17 225.91 311.25 217.66 315.28 215.07",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.6,218.91l3.45-12.63s-1.67-3.14-1.31-3.8,2.16-9.14,3.44-10.06,6.55.65,7.08,1.51-5.05,12.35-5.05,12.35l-2,13.69Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,221c9.5,9.72-9.53,31.74-20.44,30.8s.28-40.86.28-40.86l7,1.15s-2.45,17.28-1.68,18.63S339.85,217.77,343,221Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,221c9.5,9.72-9.53,31.74-20.44,30.8s.28-40.86.28-40.86l7,1.15s-2.45,17.28-1.68,18.63S339.85,217.77,343,221Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.3 209.69 321.27 212.99 331 213.85 331 210.97 322.3 209.69",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.82,
    y: 235.8,
    width: 5.52,
    height: 9.02,
    rx: 0.79,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.15,
    y: 236.4,
    width: 4.48,
    height: 6.13,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 233.63,
    width: 0.99,
    height: 3.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,389.17a8.88,8.88,0,0,1,3.17-.81h0s3.8-2.23,7.56-10.92l4.23,0a3.48,3.48,0,0,1,3.26,2.33,1.87,1.87,0,0,1,.12.58,26.08,26.08,0,0,1-.33,3.05,84.35,84.35,0,0,1-2.47,10l-.72-.18,1.3-6.32c.44-2.14-1.82-.07-2.86,2.09s-2.65,4.35-7.33,3.28C224.19,390.93,222,390.15,223.71,389.17Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.21,375.17s-5.29,11.06-8.33,13.19c0,0,4.08,2.43,8.33-3,5.49-7,6.84-5.05,6.84-5.05a20.1,20.1,0,0,0-.67-3.57C240.56,374.5,235.21,375.17,235.21,375.17Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.93,415.52a9.25,9.25,0,0,1,2.89-1.54h0s3.16-3.07,4.75-12.4l4.11-1a3.49,3.49,0,0,1,3.71,1.5,2.07,2.07,0,0,1,.26.54,23.88,23.88,0,0,1,.41,3,84.1,84.1,0,0,1-.05,10.26h-.74l-.23-6.44c-.09-2.19-1.78.36-2.29,2.71s-1.54,4.84-6.34,4.91C282.82,417.12,280.5,416.88,281.93,415.52Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.78,399.19s-2.51,12-5,14.79c0,0,4.54,1.4,7.38-4.87,3.68-8.1,5.45-6.52,5.45-6.52a20,20,0,0,0-1.49-3.31C294.82,397.28,289.78,399.19,289.78,399.19Z",
    style: {
      fill: "#e4897b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.78,
    y: 157.15,
    width: 45.05,
    height: 25.07,
    rx: 5.07,
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.85 179.36 344.33 193.66 361.3 180.32 354.85 179.36",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.24,169.68a1.48,1.48,0,1,1-1.47-1.47A1.47,1.47,0,0,1,355.24,169.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.93,169.68a1.48,1.48,0,1,1-1.47-1.47A1.47,1.47,0,0,1,362.93,169.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.62,169.68a1.48,1.48,0,1,1-1.47-1.47A1.47,1.47,0,0,1,370.62,169.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.31,169.68a1.48,1.48,0,1,1-1.47-1.47A1.47,1.47,0,0,1,378.31,169.68Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bird--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.08,
    y: 137.45,
    width: 31.05,
    height: 19.52,
    rx: 1.38,
    transform: "translate(97.86 -93.65) rotate(28.31)",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.08,
    y: 137.45,
    width: 31.05,
    height: 19.52,
    rx: 1.38,
    transform: "translate(97.86 -93.65) rotate(28.31)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.25,133.69,232,148.24a3.18,3.18,0,0,0,3.12,1.66l16.21-1.6-16.5,2.43a3.38,3.38,0,0,1-3.56-1.92Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.34,131c.27-5.56,4.39-16.77,9.4-20.2s1.71,1.32,1.71,1.32,4.75-4.62,7.25-4.48,0,3,0,3,5.15-3.17,7.52-3,0,2.91,0,2.91,4.22-3,5.93-1.59-21.89,17-24.52,23.34S205.07,136.61,205.34,131Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.34,131c.27-5.56,4.39-16.77,9.4-20.2s1.71,1.32,1.71,1.32,4.75-4.62,7.25-4.48,0,3,0,3,5.15-3.17,7.52-3,0,2.91,0,2.91,4.22-3,5.93-1.59-21.89,17-24.52,23.34S205.07,136.61,205.34,131Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,130.16l3.15,2a.26.26,0,0,1-.16.48l-3.31-.26.28,2.54a.28.28,0,0,1-.49.22L223.18,133Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,130.16l3.15,2a.26.26,0,0,1-.16.48l-3.31-.26.28,2.54a.28.28,0,0,1-.49.22L223.18,133Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,117.64s4.36-3,10.95-1.06c0,0,1.89,8.71,7.08,11.61,2.85,1.59,9.82,1.45,15.34-.33,6.55-2.12,9.75-2.12,10.94.33s-.13,5-5.14,6.19-9,9.89-18.07,10-13.89-9-11.6-17A24.16,24.16,0,0,0,181.37,117.64Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,117.64s4.36-3,10.95-1.06c0,0,1.89,8.71,7.08,11.61,2.85,1.59,9.82,1.45,15.34-.33,6.55-2.12,9.75-2.12,10.94.33s-.13,5-5.14,6.19-9,9.89-18.07,10-13.89-9-11.6-17A24.16,24.16,0,0,0,181.37,117.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.18,129.84a.45.45,0,1,1-.45-.45A.45.45,0,0,1,223.18,129.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36,137.16c-5.37,1.46-17.31,1-22.11-2.7s.72-2,.72-2-5.85-3.09-6.5-5.51,2.88-.94,2.88-.94-4.6-3.91-5.2-6.21,2.76-.9,2.76-.9-4.19-3.08-3.34-5.15,22.94,15.57,29.77,16.12S205.8,135.68,200.36,137.16Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36,137.16c-5.37,1.46-17.31,1-22.11-2.7s.72-2,.72-2-5.85-3.09-6.5-5.51,2.88-.94,2.88-.94-4.6-3.91-5.2-6.21,2.76-.9,2.76-.9-4.19-3.08-3.34-5.15,22.94,15.57,29.77,16.12S205.8,135.68,200.36,137.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.16,112.83a.25.25,0,0,1-.12,0c-.93-.33-1.88-.64-2.84-.93a.38.38,0,0,1-.25-.47.38.38,0,0,1,.47-.25c1,.29,1.93.61,2.87,1a.37.37,0,0,1-.13.72Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.72,194a.38.38,0,0,1-.38-.37.38.38,0,0,1,.37-.38,35.8,35.8,0,0,0,5.93-.58.38.38,0,0,1,.44.3.37.37,0,0,1-.3.44,36.3,36.3,0,0,1-6.06.59Zm-6-.32h0a51.69,51.69,0,0,1-6-1,.38.38,0,0,1-.29-.45.38.38,0,0,1,.45-.28,55.76,55.76,0,0,0,5.9,1,.38.38,0,0,1,0,.75Zm17.77-2a.37.37,0,0,1-.34-.22.37.37,0,0,1,.19-.5,19.44,19.44,0,0,0,5-3.13.38.38,0,0,1,.5.57,20.54,20.54,0,0,1-5.19,3.25A.4.4,0,0,1,116.47,191.7ZM87,191a.25.25,0,0,1-.12,0c-1.9-.63-3.81-1.37-5.66-2.18a.38.38,0,0,1,.31-.69c1.82.8,3.7,1.53,5.59,2.16a.38.38,0,0,1,.23.48A.37.37,0,0,1,87,191Zm-11-4.86a.31.31,0,0,1-.18,0c-1.79-1-3.53-2.08-5.15-3.21a.37.37,0,1,1,.43-.61c1.6,1.11,3.31,2.18,5.09,3.17a.37.37,0,0,1,.14.51A.39.39,0,0,1,75.93,186.17Zm49.44-2.29a.31.31,0,0,1-.18,0,.37.37,0,0,1-.14-.51c.31-.54.6-1.1.86-1.68a20.62,20.62,0,0,0,1.3-3.81.39.39,0,0,1,.46-.28.38.38,0,0,1,.27.46,22.33,22.33,0,0,1-1.35,3.94c-.27.6-.57,1.19-.89,1.75A.38.38,0,0,1,125.37,183.88Zm-59.3-4.62a.38.38,0,0,1-.24-.09,43.51,43.51,0,0,1-4.27-4.34.38.38,0,0,1,0-.53.37.37,0,0,1,.52,0,42.93,42.93,0,0,0,4.19,4.25.38.38,0,0,1,0,.53A.37.37,0,0,1,66.07,179.26Zm62.18-6.94a.37.37,0,0,1-.37-.38,35,35,0,0,0-.55-5.93.38.38,0,0,1,.3-.44.39.39,0,0,1,.44.31,35.49,35.49,0,0,1,.56,6.06.38.38,0,0,1-.38.38Zm-2-11.86a.38.38,0,0,1-.36-.27c-.51-1.75-1.14-3.61-1.91-5.69a.37.37,0,0,1,.22-.49.38.38,0,0,1,.48.22c.78,2.1,1.41,4,1.93,5.74a.38.38,0,0,1-.25.47Zm-4.14-11.35a.36.36,0,0,1-.33-.21c-.64-1.6-1.51-3.44-2.42-5.39l0-.1a.38.38,0,0,1,.68-.32l0,.1c.92,2,1.78,3.81,2.42,5.38a.39.39,0,0,1-.2.51Zm-5-11a.37.37,0,0,1-.35-.22c-.9-2.09-1.62-3.94-2.19-5.65a.38.38,0,0,1,.23-.48.38.38,0,0,1,.48.24c.56,1.69,1.27,3.52,2.17,5.59a.37.37,0,0,1-.2.49A.32.32,0,0,1,117.2,138.13Zm-3.66-11.46a.38.38,0,0,1-.37-.32,20.66,20.66,0,0,1-.26-3.24,14.79,14.79,0,0,1,.26-2.89.38.38,0,0,1,.74.15,14,14,0,0,0-.25,2.74,20.56,20.56,0,0,0,.25,3.13.39.39,0,0,1-.31.43Zm2.61-11.36a.37.37,0,0,1-.24-.08.38.38,0,0,1,0-.53,16,16,0,0,1,4.81-3.81.38.38,0,0,1,.51.15.39.39,0,0,1-.16.51,15.24,15.24,0,0,0-4.58,3.63A.37.37,0,0,1,116.15,115.31Zm40.32-4.9h-.08c-1.92-.4-3.91-.74-5.92-1a.37.37,0,0,1-.32-.42.37.37,0,0,1,.42-.32c2,.26,4,.6,6,1a.38.38,0,0,1-.07.75Zm-30-.85a.37.37,0,0,1-.08-.74,39.56,39.56,0,0,1,6-.87.38.38,0,0,1,.4.35.37.37,0,0,1-.35.4,38,38,0,0,0-5.9.85Zm18-.7h0c-1.74-.12-3.81-.25-6-.29a.38.38,0,0,1-.37-.38.37.37,0,0,1,.38-.37c2.21.05,4.3.17,6,.29a.37.37,0,0,1,.35.4A.38.38,0,0,1,144.52,108.86Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.36,170a.37.37,0,0,1-.33-.19,24.54,24.54,0,0,1-1.35-2.72.37.37,0,0,1,.2-.49.38.38,0,0,1,.49.2,25.88,25.88,0,0,0,1.31,2.64.36.36,0,0,1-.32.56Z",
    style: {
      fill: "#455590"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 249.04,
    width: 37.96,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 249.04,
    width: 37.96,
    height: 7.78,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 249.04,
    width: 15.99,
    height: 7.78,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.85 250.16 175.64 250.16 141.85 251.12 141.85 250.16",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.81 251.51 150.52 252.24 179.81 252.24 179.81 251.51",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.4 253.69 157.84 253.1 179.07 253.69 157.84 254.02 143.4 253.69",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.85 255.34 166.87 255.34 141.85 255.93 141.85 255.34",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.75 255.93 163.04 256.24 179.81 256.24 179.75 255.93",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.57,
    y: 241.26,
    width: 37.96,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.57,
    y: 241.26,
    width: 37.96,
    height: 7.78,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.57,
    y: 241.26,
    width: 15.99,
    height: 7.78,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.57 242.38 170.36 242.38 136.57 243.33 136.57 242.38",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.53 243.73 145.24 244.46 174.53 244.46 174.53 243.73",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.11 245.91 152.55 245.31 173.78 245.91 152.55 246.24 138.11 245.91",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.57 247.55 161.59 247.55 136.57 248.15 136.57 247.55",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.47 248.15 157.76 248.46 174.53 248.46 174.47 248.15",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.9,
    y: 233.47,
    width: 37.96,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.9,
    y: 233.47,
    width: 37.96,
    height: 7.78,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.9,
    y: 233.47,
    width: 15.99,
    height: 7.78,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.9 234.59 174.69 234.59 140.9 235.55 140.9 234.59",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.86 235.94 149.57 236.67 178.86 236.67 178.86 235.94",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.45 238.12 156.89 237.53 178.12 238.12 156.89 238.45 142.45 238.12",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.9 239.77 165.92 239.77 140.9 240.36 140.9 239.77",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.81 240.36 162.1 240.67 178.86 240.67 178.81 240.36",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.15 256.66 205.13 252.93 245.69 252.93 264.36 254.8 265.07 256.66 204.15 256.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.69 252.93 245.69 256.66 204.15 256.66 205.13 252.93 245.69 252.93",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.54,235.08a3.19,3.19,0,0,1-3.22,3.57H172.2a4,4,0,0,1-3.89-3.57l-3.69-39.77a3.41,3.41,0,0,1,.08-1.16,3.17,3.17,0,0,1,3.14-2.41H230a4,4,0,0,1,3.89,3.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,238.65H172.2a4,4,0,0,1-3.89-3.57l-3.69-39.77a3.41,3.41,0,0,1,.08-1.16h61.9a4,4,0,0,1,3.89,3.57l3.69,39.77A3.41,3.41,0,0,1,234.1,238.65Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.42 214.26 204.27 214.26 200.85 251.05 221.17 254.1 221.17 256.66 178.37 256.66 178.37 254.1 187.14 251.05 191.42 214.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.27 214.26 194.75 256.08 187.14 255.85 191.42 214.26 204.27 214.26",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.21 417.07 198.09 417.07 187.08 263.82 195.21 263.82 204.21 417.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.22 417.07 198.09 417.07 187.62 271.44 187.08 264.07 195.21 264.07 195.65 271.44 204.22 417.07",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.65 271.07 187.62 271.07 187.08 264.07 195.21 264.07 195.65 271.07",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.17 417.07 243.05 417.07 242.05 263.82 250.17 263.82 249.17 417.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.18 264.07 250.02 288.8 249.18 417.07 243.05 417.07 242.21 288.8 242.05 264.07 250.18 264.07",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.18 264.07 250.02 289.07 242.21 289.07 242.05 264.07 250.18 264.07",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.21 417.07 308.09 417.07 297.08 263.82 305.21 263.82 314.21 417.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.22 417.07 308.09 417.07 297.62 271.44 297.08 264.07 305.21 264.07 305.65 271.44 314.22 417.07",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.65 271.07 297.62 271.07 297.08 264.07 305.21 264.07 305.65 271.07",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.13 417.07 128.01 417.07 137.01 263.82 145.14 263.82 134.13 417.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.14 264.07 144.6 271.44 134.13 417.07 128.01 417.07 136.57 271.44 137.01 264.07 145.14 264.07",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.01 264.07 145.14 264.07 144.6 271.07 136.57 271.07 137.01 264.07",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57,260H311.65a0,0,0,0,1,0,0v5.51a2.16,2.16,0,0,1-2.16,2.16H132.73a2.16,2.16,0,0,1-2.16-2.16V260A0,0,0,0,1,130.57,260Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57,260H311.65a0,0,0,0,1,0,0v5.51a2.16,2.16,0,0,1-2.16,2.16H132.73a2.16,2.16,0,0,1-2.16-2.16V260A0,0,0,0,1,130.57,260Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.57,
    y: 259.99,
    width: 181.08,
    height: 3.84,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.45,261H126.77a2.16,2.16,0,0,1-2.16-2.16h0a2.17,2.17,0,0,1,2.16-2.17H315.45a2.17,2.17,0,0,1,2.16,2.17h0A2.16,2.16,0,0,1,315.45,261Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.45,261H126.77a2.16,2.16,0,0,1-2.16-2.16h0a2.17,2.17,0,0,1,2.16-2.17H315.45a2.17,2.17,0,0,1,2.16,2.17h0A2.16,2.16,0,0,1,315.45,261Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.81,250l2.32-3.48a2.5,2.5,0,0,1,2.08-1.11h2.94a2.46,2.46,0,0,1,.72.11l10.49,3.18a2.47,2.47,0,0,1,1.42,1.11l1.51,2.53Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.29,252.34,277,250.68l-6.21-.68,2.32-3.48a2.5,2.5,0,0,1,2.08-1.11h2.94a2.58,2.58,0,0,1,.73.11l.23.07,10.25,3.11a2.48,2.48,0,0,1,1.43,1.11Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.29,252.34,277,250.68l2.09-5.09,10.25,3.11a2.48,2.48,0,0,1,1.43,1.11Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.55,256.33v.33H267.13l1.2-4.69a4,4,0,0,1,3.89-3H286.6a3.94,3.94,0,0,1,1.4.25l1.8.67,7.14,2.66A4,4,0,0,1,299.55,256.33Z",
    style: {
      fill: "#455590"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.55,256.33v.33H286.24l.71-5.07a2.13,2.13,0,0,1,2.85-1.69l7.14,2.66A4,4,0,0,1,299.55,256.33Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.31,253.22l4.24-12.71a.93.93,0,0,1,1.32-.54h0a1,1,0,0,1,.48,1.08l-3.57,13.56S288.41,255.57,288.31,253.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.81 255.61 268.93 255.61 269.29 253.76 271.17 253.76 270.81 255.61",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.61 255.54 271.73 255.54 272.09 253.69 273.97 253.69 273.61 255.54",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.df079f46ccf39cd518b63f3b9275ad95.svg";
export { ForwardRef as ReactComponent };